import { combineReducers } from 'redux';

import uploadData from './uploadData.reducer';
import jobs from './jobs.reducer';
import job from './job.reducer';
import user from './user.reducer';
import timesheet from './timesheet.reducer';
import timesheets from './timesheets.reducer';
import expenses from './expenses.reducer';
import expense from './expense.reducer';
import cv from './cv.reducer';
import languages from './languages.reducer';
import jobAlerts from './jobAlerts.reducer';
import appNotifications from './appNotifications.reducer';
import constFromApi from './constFromApi.reducer';
import accessToParts from './accessToParts.reducer';
import filtersOptionsFromApi from './filtersOptionsFromApi.reducer';

export default combineReducers({
  uploadData,
  jobs,
  job,
  timesheet,
  timesheets,
  expenses,
  expense,
  user,
  cv,
  languages,
  jobAlerts,
  appNotifications,
  constFromApi,
  accessToParts,
  filtersOptionsFromApi
});
